import { render, staticRenderFns } from "./PendingCollegesList.vue?vue&type=template&id=ec54bf92&"
import script from "./PendingCollegesList.vue?vue&type=script&lang=js&"
export * from "./PendingCollegesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports